import Flouci from './Flouci';
export default Flouci;